import { unitsText } from './chunk-FUSVBGCF.mjs';
import { filterDiffFunction } from './chunk-RPUBZJ2D.mjs';
import { formatMoney } from './chunk-V5NTXSTJ.mjs';

// src/helpers/factories/settingsDifferences/diffTaxesFactory.ts
var formatTax = (type, typeData) => {
  if (type === "percent" /* PERCENT */)
    return `${typeData == null ? void 0 : typeData.rate}%`;
  else if ((type === "fixed" /* FIXED */ || type === "volume" /* VOLUMETRIC */) && typeData) {
    return formatMoney(null, typeData.rate) + (type === "volume" /* VOLUMETRIC */ ? ` / ${typeData.interval.toLocaleString()} ${unitsText[typeData.unit]}` : "");
  }
  return "N/A";
};
var TaxesFieldLabels = /* @__PURE__ */ ((TaxesFieldLabels2) => {
  TaxesFieldLabels2[TaxesFieldLabels2["name"] = 0] = "name";
  TaxesFieldLabels2[TaxesFieldLabels2["orderTypes"] = 1] = "orderTypes";
  TaxesFieldLabels2[TaxesFieldLabels2["taxType"] = 2] = "taxType";
  TaxesFieldLabels2[TaxesFieldLabels2["tableTypeData"] = 3] = "tableTypeData";
  TaxesFieldLabels2[TaxesFieldLabels2["typeData"] = 4] = "typeData";
  TaxesFieldLabels2[TaxesFieldLabels2["rate"] = 5] = "rate";
  TaxesFieldLabels2[TaxesFieldLabels2["unit"] = 6] = "unit";
  TaxesFieldLabels2[TaxesFieldLabels2["interval"] = 7] = "interval";
  TaxesFieldLabels2[TaxesFieldLabels2["repeat"] = 8] = "repeat";
  TaxesFieldLabels2[TaxesFieldLabels2["to"] = 9] = "to";
  TaxesFieldLabels2[TaxesFieldLabels2["from"] = 10] = "from";
  TaxesFieldLabels2[TaxesFieldLabels2["tax"] = 11] = "tax";
  TaxesFieldLabels2[TaxesFieldLabels2["id"] = 12] = "id";
  return TaxesFieldLabels2;
})(TaxesFieldLabels || {});
var returnLabel = (field) => {
  if (field in TaxesFieldLabels) {
    return field;
  }
};
var diffTaxesFactory = (diffArray) => {
  if (diffArray.length > 0) {
    const taxes = generateTaxesObj(diffArray);
    return taxes;
  }
  return null;
};
var generateTaxesObj = (diffArray) => {
  const taxes = [];
  const diffArrayCopy = [];
  diffArray.forEach((diff) => {
    if (diff.path.length > 2 && diff.path[1] === "tableTypeData" && diff.rhs && typeof diff.rhs === "object") {
      Object.keys(diff.rhs).forEach((key) => {
        var _a;
        const formattedDiff = {
          kind: "E",
          type: diff.kind,
          rhs: (_a = diff.rhs) == null ? void 0 : _a[key],
          path: [...diff.path, key]
        };
        diffArrayCopy.push(formattedDiff);
      });
    } else {
      diffArrayCopy.push(diff);
    }
  });
  diffArrayCopy.forEach((diff) => {
    return filterDiffFunction(
      diff,
      ({ field }) => {
        const id = Number(diff.path[0]);
        if (diff.kind === "E") {
          const customNewDiff = {
            field,
            label: returnLabel(field) || "",
            value: diff.rhs
          };
          if (!taxes.find((row) => {
            if (diff.path.length > 2 && diff.path[1] === "tableTypeData") {
              return row.id === Number(diff.path[2]);
            }
            return row.id === id;
          })) {
            const change = {
              id,
              label: String(id) || "",
              changes: [customNewDiff],
              action: "update"
            };
            if (diff.path.length > 2 && diff.path[1] === "tableTypeData") {
              change.taxId = Number(diff.path[0]);
              change.id = Number(diff.path[2]);
              change.label = String(diff.path[2]) || "";
              change.action = diff.type === "N" ? "add" : "update";
            }
            taxes.push(change);
          } else {
            for (const [i, row] of taxes.entries()) {
              if (diff.path.length > 2 && diff.path[1] === "tableTypeData") {
                if (row.id === Number(diff.path[2])) {
                  taxes[i].changes = [...row.changes, customNewDiff];
                  break;
                }
                continue;
              }
              if (row.id === id) {
                taxes[i].changes = [...row.changes, customNewDiff];
                break;
              }
            }
          }
        } else if (diff.kind === "N") {
          const changes = [];
          for (const [key, val] of Object.entries(
            diff.rhs
          )) {
            changes.push({
              field: key,
              label: returnLabel(key) || "",
              value: val
            });
          }
          taxes.push({
            id,
            label: returnLabel(String(id)) || "",
            changes,
            action: "add"
          });
        } else if (diff.kind === "D") {
          const change = {
            id,
            label: returnLabel(String(id)) || "",
            changes: [],
            action: "remove"
          };
          if (diff.path.length > 2 && diff.path[1] === "tableTypeData") {
            change.taxId = Number(diff.path[0]);
            change.id = Number(diff.path[2]);
            change.label = String(diff.path[2]) || "";
          }
          taxes.push(change);
        }
      },
      returnLabel
    );
  });
  return taxes;
};

export { diffTaxesFactory, formatTax };
